import React from 'react'
import QueueWait from '../../components/queue/QueueWait'

export default function QueueWaitScreen() {
    return (
        <div><QueueWait /></div>
    )
}
